import { UNRESOLVED_CONNECTOR_STATUSES } from "../../connect"

export const isResolved = (status: string) =>
  !UNRESOLVED_CONNECTOR_STATUSES.includes(status)

export const isReconnectRequired = (status: string) =>
  status === "FAILED" || status === "RECONNECT" || status === "UPGRADE"
